import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import { ATTENDANCE_TYPE, JOIN_TIME, LEAVE_TIME, NAME, TIME_ATTENDED, DROPS, PARTICIPANT_NAME_TOOLTIP_CLASS } from '../../constants/report.constant';
import {
  attachHoverforEllipsedToolTip,
  copyPreservedTitleValueToInnerHtml,
  isOriginalTitleValuePreserved,
  removeToolTip
} from '../../helper/commonUtils';
import ToolTipModal from './ToolTipModal';

const GroupClassTable = ({ participantList }) => {
  const [participantToolTipModal, setParticipantToolTipModal] = useState(false);
  const [dropRejoinTime, setDropRejoinTime] = useState([]);

  const closeParticipantToolTipModal = () => setParticipantToolTipModal(false);
  useEffect(() => {
    attachHoverforEllipsedToolTip(PARTICIPANT_NAME_TOOLTIP_CLASS);
  }, [participantList]);

  const participantDropCountClick = participant => {
    if (participantToolTipModal === true) {
      return;
    }
    setParticipantToolTipModal(true);
    setDropRejoinTime(participant);
  };

  const disableParticipantTableScroll = isToolTipModalOpened => {
    const participantTableElement = document.getElementById('participant-tooltip-table');
    const participantTableContainerElement = participantTableElement.parentElement;
    if (participantTableContainerElement) {
      participantTableContainerElement.style.overflow = isToolTipModalOpened ? 'hidden' : 'auto';
    }
  };

  const disableNameToolTipModal = isParticipantTooltipModalOpened => {
    if (isParticipantTooltipModalOpened) {
      removeToolTip(PARTICIPANT_NAME_TOOLTIP_CLASS, true);
      return;
    }
    if (isOriginalTitleValuePreserved(PARTICIPANT_NAME_TOOLTIP_CLASS)) {
      copyPreservedTitleValueToInnerHtml(PARTICIPANT_NAME_TOOLTIP_CLASS);
      attachHoverforEllipsedToolTip(PARTICIPANT_NAME_TOOLTIP_CLASS);
    }
  };

  useEffect(() => {
    disableParticipantTableScroll(participantToolTipModal);
    disableNameToolTipModal(participantToolTipModal);
  }, [participantToolTipModal]);

  return (
    <Table hover bordered className="vve-group-class-table" id="participant-tooltip-table">
      <thead>
        <tr className="vve-text-bold">
          <th>{NAME}</th>
          <th className="vve-text-center">{DROPS}</th>
          <th className="vve-text-center">{ATTENDANCE_TYPE}</th>
          <th className="vve-text-center">{JOIN_TIME}</th>
          <th className="vve-text-center">{LEAVE_TIME}</th>
          <th className="vve-text-center">{TIME_ATTENDED}</th>
        </tr>
      </thead>
      <tbody>
        {participantList?.map(participant => (
          <tr key={participant.name}>
            <td className={PARTICIPANT_NAME_TOOLTIP_CLASS}>{participant.name}</td>
            <td className="vve-text-center vve-drop-column">
              {participant.drops > 0 && <p onClick={() => participantDropCountClick(participant)}> {participant.drops}</p>}
            </td>
            <td className="vve-text-center">{participant.role}</td>
            <td className="vve-text-center">{participant.joinTime}</td>
            <td className="vve-text-center">{participant.leaveTime}</td>
            <td className="vve-text-center">{participant.timeAttended}</td>
          </tr>
        ))}
      </tbody>
      <ToolTipModal isOpen={participantToolTipModal} onClose={closeParticipantToolTipModal} participantData={dropRejoinTime}></ToolTipModal>
    </Table>
  );
};

GroupClassTable.propTypes = {
  participantList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      drops: PropTypes.number,
      role: PropTypes.string,
      joinTime: PropTypes.string,
      leaveTime: PropTypes.string,
      timeAttended: PropTypes.string
    })
  )
};

export default GroupClassTable;
